
export default function Dot (){
     return <span className="mx-c5">.</span>
}